import { Progress } from 'antd';
import styled from 'styled-components';

export const SectionHeaderStyled = styled.div`
	width: 100%;
	margin-top: 30px;
	margin-bottom: 5px;

	h3 {
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		margin-bottom: 12px;
	}
`;

export const StepperContainer = styled.div`
	display: flex;
	align-items: center;
	/* margin-bottom: 10px; */

	gap: 15px;
`;

export const StepperMessage = styled.span`
	font-size: 12px;
	font-weight: 500;
	line-height: 14px;

	color: #595959;
`;

export const StyledStepper = styled(Progress)`
	flex: 1;
	max-width: 500px;

	.ant-progress-steps-item {
		border-radius: 10px;
		flex: 1;

		margin-right: 4px;

		&:last-of-type {
			margin-right: 0;
		}
	}
`;
